import { render, staticRenderFns } from "./UseHistory.vue?vue&type=template&id=79205532&scoped=true&"
import script from "./UseHistory.vue?vue&type=script&lang=js&"
export * from "./UseHistory.vue?vue&type=script&lang=js&"
import style0 from "./UseHistory.vue?vue&type=style&index=0&id=79205532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79205532",
  null
  
)

export default component.exports